import { render } from "./ChatWrapper.vue?vue&type=template&id=20c95f9e&scoped=true"
import script from "./ChatWrapper.vue?vue&type=script&lang=js"
export * from "./ChatWrapper.vue?vue&type=script&lang=js"

import "./ChatWrapper.vue?vue&type=style&index=0&id=20c95f9e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20c95f9e"]])

export default __exports__